import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, DatePicker, Input, message } from "antd";
import ModalConfirm from "app/components/ConfirmExit";
import LayoutTableV2 from "app/components/TableV2";
import { EMPTY_VALUE } from "constant";
import { useHandleSubmitApi } from "hook";
import { ILeadOutputModel } from "interfaces/lead";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { LeadServices } from "services/lead";

export interface ILeadPageProps {}

export default function LeadListPage(props: ILeadPageProps) {
  const { RangePicker } = DatePicker;
  const [list, setList] = useState<ILeadOutputModel[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [totalRecord, setTotalRecord] = useState<number>(0);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize] = useState<number>(15);
  const [dates, setDates] = useState([]);
  const [leadId, setLeadId] = useState<string | null>(null);

  useEffect(() => {
    handleFetchInventories({ dates });
    // eslint-disable-next-line
  }, [dates, searchValue, pageNum, pageSize]);

  const [handleFetchInventories, loadingPaginate] = useHandleSubmitApi(async (options?: { dates: string[] }) => {
    let input: any = {
      sortBy: "createdAt",
      sortOrder: "desc",
      pageNum,
      pageSize,
      searchValue,
    };

    if (!!(options?.dates?.length === 2)) {
      input["fromDate"] = options?.dates[0];
      input["toDate"] = options?.dates[1];
    }

    const dataRes = await LeadServices.getLead(input);
    if (dataRes) {
      setList(dataRes.data);

      if (dataRes.meta) {
        const { pageNum, totalRecords } = dataRes.meta;
        setTotalRecord(totalRecords);
        setPageNum(pageNum);
      }
    }
  });

  const [handleDeleteLead] = useHandleSubmitApi(async (leadId: string) => {
    await LeadServices.deleteLead(leadId);
    message.success("Xoá thông tin thành công!");
    handleFetchInventories({ dates });
  });

  const columns = [
    {
      title: "Họ và tên",
      dataIndex: "fullName",
      key: "fullName",
      fixed: "left",
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      key: "phone",
      fixed: "left",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Tên doanh nghiệp",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Thời gian tạo",
      dataIndex: "createdAt",
      key: "createdAt",
    },
  ];

  const headers = columns.map((c) => ({ label: c.title, key: c.key }));
  const data = list?.map((value) => ({
    key: value.id,
    fullName: value.fullName,
    phone: value.phone,
    email: value.email,
    companyName: value.companyName,
    description: value.description,
    createdAt: value.createdAt ? moment(value.createdAt).format("YYYY-MM-DD HH:mm:ss") : EMPTY_VALUE,
    action: (
      <DeleteOutlined
        style={{ color: "red" }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setLeadId(value.id);
        }}
      />
    ),
  })) as any;

  return (
    <React.Fragment>
      <LayoutTableV2<ILeadOutputModel>
        loading={loadingPaginate}
        onClick={(record) => {
          //   navigate({
          //     pathname: PAGE_ROUTE.ADM_POST_EDIT,
          //     search: createSearchParams({
          //       id: record.id,
          //     }).toString(),
          //   });
        }}
        header={() => (
          <React.Fragment>
            <div className="layout-list__header__menu" style={{ width: "20rem" }}></div>
            <div className="d-flex">
              <RangePicker
                className="mr_1"
                onChange={(values: any, dateStrings) => setDates(values?.map((d: any) => new Date(d).toISOString()))}
                style={{ width: 400 }}
                placeholder={["Ngày Bắt Đầu", "Ngày Kết Thúc"]}
              />

              <Input
                placeholder="Nhập thông tin tìm kiếm"
                className="mr_1"
                suffix={<SearchOutlined />}
                onChange={_.debounce((e) => {
                  setSearchValue(e.target.value);
                }, 200)}
                // value={searchValue}
                style={{ width: 300 }}
                allowClear
              />

              <CSVLink
                data={data}
                headers={headers}
                filename={`Thong_Tin_Khach_Tiem_Nang_${new Date().toISOString()}.csv`}
              >
                <Button size="large" className="btn" style={{ width: 200 }}>
                  Xuất báo cáo
                </Button>
              </CSVLink>
            </div>
          </React.Fragment>
        )}
        data={data}
        columns={[
          {
            title: "Họ và tên",
            dataIndex: "fullName",
            key: "fullName",
            fixed: "left",
          },
          {
            title: "Số điện thoại",
            dataIndex: "phone",
            key: "phone",
            fixed: "left",
          },
          {
            title: "Email",
            dataIndex: "email",
            key: "email",
          },
          {
            title: "Tên doanh nghiệp",
            dataIndex: "companyName",
            key: "companyName",
          },
          {
            title: "Mô tả",
            dataIndex: "description",
            key: "description",
          },
          {
            title: "Thời gian tạo",
            dataIndex: "createdAt",
            key: "createdAt",
          },
          {
            title: "",
            dataIndex: "action",
            key: "action",
            fixed: "right",
            width: 20,
          },
        ]}
        optionPaginate={{
          numberRecordShow: list.length,
          totalRecord: totalRecord,
          pageNum: pageNum,
          pageSize: pageSize,
          onChangePageNum: (number) => {
            setPageNum(number);
          },
        }}
      />

      {!!leadId && (
        <ModalConfirm
          visible={!!leadId}
          title={`Bạn có chắc chắn muốn xoá?`}
          cancel={() => setLeadId(null)}
          confirm={() => {
            setLeadId(null);
            handleDeleteLead(leadId);
          }}
        />
      )}
    </React.Fragment>
  );
}
